import React from "react";

import Dashboard from "../pages/Dashboard";
import DocumentsList from "../pages/DocumentsList";
import DocumentForm from "../pages/DocumentForm";
import CategoriesList from "../pages/CategoriesList";
import SourcesList from "../pages/SourcesList";
import TagsList from "../pages/TagsList";
import Profile from "../pages/Profile";

const protectedRoutes = [
  { path: "/dashboard", element: <Dashboard /> },
  { path: "/documents", element: <DocumentsList /> },
  { path: "/documents/new", element: <DocumentForm /> },
  { path: "/documents/:id/edit", element: <DocumentForm /> },
  { path: "/categories", element: <CategoriesList /> },
  { path: "/sources", element: <SourcesList /> },
  { path: "/tags", element: <TagsList /> },
  { path: "/profile", element: <Profile /> }
];

export default protectedRoutes;